import { handleActions } from 'redux-actions';

export default handleActions(
	{
		LOAD_LIB_GOOGLE_FULFILLED: state => ({
			...state,
			google: true,
		}),

		LOAD_LIB_FACEBOOK_FULFILLED: state => ({
			...state,
			facebook: true,
		}),

		RESIZE_WINDOW: (state, action) => ({
			...state,
			window: {
				...state.window,
				width: action.payload.width,
				height: action.payload.height,
			},
		}),

		SCROLL_WINDOW: (state, action) => ({
			...state,
			window: {
				...state.window,
				scrollY: action.payload.scrollY,
			},
		}),

		VISIBLE_WINDOW: (state, action) => ({
			...state,
			window: {
				...state.window,
				visible: action.payload.visible,
			},
		}),

		MATCH_MEDIA: (state, action) => ({
			...state,
			window: {
				...state.window,
				media: action.payload.media,
			},
		}),

		UPDATE_HOME_ACTIVE_SECTION: (state, action) => ({
			...state,

			home: {
				...state.home,
				activeSection: action.payload.activeSection,
			},
		}),

		NAVI_TOGGLE: (state, action) => ({
			...state,
			naviToggle: action.payload.toggle,
		}),

		LOAD_TOGGLE: (state, action) => ({
			...state,
			loading: action.payload.toggle,
		}),
	},
	{
		google: false,
		facebook: false,
		window: {
			width: document.documentElement.clientWidth,
			height: document.documentElement.clientHeight,
			scrollY: window.scrollY || window.pageYOffset,
			media: '',
			visible: !document.hidden,
		},

		home: {
			activeSection: 0,
		},
		naviToggle: false,

		loading: false,
	},
);



// WEBPACK FOOTER //
// ./src/reducers/global.js